import React, { Component } from 'react';
import { Button, Container } from 'react-bulma-components';
import NavigationBar from '../NavigationBar/NavigationBar';
import { observer } from 'mobx-react';
import { observable, toJS } from 'mobx';
import ItemStore from 'stores/AccountsOverview/ItemsStore';
import FetchView from '../../dumb/FetchView/FetchView';
import Select from 'react-select';
import './index.css';
import RestClient from '../../../shared/Network/RestClient';
import { toast } from 'react-toastify';
import { Table, TableCell, TableHead, TableBody, TableRow, Switch } from '@material-ui/core';
import { CsvBuilder } from 'filefy';
import moment from 'moment';

const metrics = [
  { label: 'POS', value: 'pos' },
  { label: 'EK', value: 'ek' },
  { label: 'UVP', value: 'uvp' },
  { label: 'VK', value: 'vk' },
];

@observer
class POSOverview extends Component {
  @observable accessor localstate = {
    isListingStatusView: false,
    skus: [],
    sku: '',
    loading: false,
    posData: [],
    listingData: [],
    selectedMetric: {},
    activeListingsOnly: false,
    filteredData: [],
    filteredListingData: [],
    activeListingsOnlyListing: false,
  };

  handleViewChange = () => {
    this.localstate.isListingStatusView = !this.localstate.isListingStatusView;
  };

  handleSwitch = () => {
    this.localstate.activeListingsOnly = !this.localstate.activeListingsOnly;
    if (this.localstate.activeListingsOnly) {
      this.localstate.filteredData = this.localstate.posData.filter((data) => {
        return data.status === 'LISTED';
      });
    } else {
      this.localstate.filteredData = this.localstate.posData;
    }
  };

  handleListingSwitch = () => {
    this.localstate.activeListingsOnlyListing = !this.localstate.activeListingsOnlyListing;
    if (this.localstate.activeListingsOnlyListing) {
      this.localstate.filteredListingData = this.localstate.listingData.filter((data) => {
        return data.status === 'LISTED';
      });
    } else {
      this.localstate.filteredListingData = this.localstate.listingData;
    }
  };

  onSkuSelectMulti = async (selectedSkus) => {
    selectedSkus = selectedSkus || [];
    this.localstate.skus = selectedSkus;
    selectedSkus = selectedSkus.map((sku) => `skus=${sku.value}`);
    const request = RestClient.prepareRequest(
      'GET',
      'accountsoverview/pos/skus?' + selectedSkus.join('&')
    );
    try {
      const res = await request.send();
      this.localstate.posData = res.data;
      if (this.localstate.activeListingsOnly) {
        this.localstate.filteredData = res.data.filter((data) => {
          return data.status === 'LISTED';
        });
      } else {
        this.localstate.filteredData = res.data;
      }
    } catch (e) {
      console.error(e);
      toast.error(e);
    }
  };

  onSkuSelectSingle = async (selectedSku) => {
    this.localstate.sku = selectedSku;
    const request = RestClient.prepareRequest(
      'GET',
      'accountsoverview/pos/skus?skus=' + selectedSku.value
    );
    try {
      const res = await request.send();
      this.localstate.listingData = res.data;
      if (this.localstate.activeListingsOnly) {
        this.localstate.filteredListingData = res.data.filter((data) => {
          return data.status === 'LISTED';
        });
      } else {
        this.localstate.filteredListingData = res.data;
      }
    } catch (e) {
      console.error(e);
      toast.error(e);
    }
  };

  selectMetric = (selectedMetric) => {
    this.localstate.selectedMetric = selectedMetric;
  };

  getTable = () => {
    if (
      this.localstate.skus?.length > 0 &&
      this.localstate.filteredData?.length > 0 &&
      this.localstate.selectedMetric.value
    ) {
      const accounts = [...new Set(this.localstate.filteredData.map((entry) => entry.account))];
      return (
        <Table
          style={{
            position: 'relative',
            borderSpacing: '0px',
            tableLayout: 'auto',
            whiteSpace: 'nowrap',
            width: 'max-content',
            margin: '50px auto',
            zIndex: '-1',
          }}
          aria-label="simple table"
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell>Account</TableCell>
              {this.localstate.skus.map((sku, index) => (
                <TableCell key={index}>{sku.value}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {accounts.map((account) => {
              return (
                <TableRow key={account}>
                  <TableCell>{account}</TableCell>
                  {this.localstate.skus.map((sku) => {
                    const entry = this.localstate.filteredData.find(
                      (item) => item.account === account && item.sku === sku.value
                    );
                    return (
                      <TableCell key={sku.value}>
                        {entry ? entry[this.localstate.selectedMetric.value] : ''}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      );
    }
  };

  getListingTable = () => {
    if (this.localstate.sku && this.localstate.listingData.length > 0) {
      return (
        <Table
          style={{
            position: 'relative',
            borderSpacing: '0px',
            tableLayout: 'auto',
            whiteSpace: 'nowrap',
            width: 'max-content',
            margin: '50px auto',
            zIndex: '-1',
          }}
          aria-label="simple table"
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell>Account</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {this.localstate.filteredListingData.map((listing) => {
              return (
                <TableRow key={listing.account}>
                  <TableCell>{listing.account}</TableCell>
                  <TableCell>{listing.status}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      );
    }
  };

  export = () => {
    const filteredSkus = [
      ...new Set(
        this.localstate.filteredData.map((item) => {
          return item.sku;
        })
      ),
    ];
    const allAccounts = [...new Set(this.localstate.filteredData.map((item) => item.account))];
    const selectedMetric = this.localstate.selectedMetric.value;
    let columns = ['Account', ...filteredSkus];
    const csvBuilder = new CsvBuilder(
      `pos-overview-${selectedMetric}-${moment().format('DDMMYYYY')}.csv`
    ).setColumns(columns);

    for (const account of allAccounts) {
      const row = [account];

      for (const sku of filteredSkus) {
        const entry = this.localstate.filteredData.find(
          (item) => item.account === account && item.sku === sku
        );

        row.push(entry ? entry[selectedMetric] : '');
      }

      csvBuilder.addRow(row);
    }

    csvBuilder.exportFile();
  };

  exportListingStatus = () => {
    const selectedSku = this.localstate.sku;
    const csvBuilder = new CsvBuilder(
      `listing-status-${selectedSku.value}-${moment().format('DDMMYYYY')}.csv`
    ).setColumns(['Account', 'Status']);

    for (const item of this.localstate.filteredListingData) {
      csvBuilder.addRow([item.account || '', item.status || '']);
    }
    csvBuilder.exportFile();
  };

  render() {
    const {
      isListingStatusView,
      loading,
      activeListingsOnly,
      activeListingsOnlyListing,
      skus,
      sku,
      selectedMetric,
    } = this.localstate;

    if (isListingStatusView) {
      return (
        <>
          <NavigationBar title="POSOverview" />
          <Container style={{ textAlign: 'center' }}>
            <Button
              onClick={this.handleViewChange}
              style={!isListingStatusView ? styles.activeBtn : styles.btn}
            >
              Standard
            </Button>
            <Button
              onClick={this.handleViewChange}
              style={isListingStatusView ? styles.activeBtn : styles.btn}
            >
              Listing Status
            </Button>
            <FetchView stores={[ItemStore]}>
              <div className="filter">
                <Select
                  className={'filter-select'}
                  placeholder={`Product`}
                  isDisabled={loading}
                  options={ItemStore.list.map((item) => ({
                    label: `${item.att_sku}`,
                    value: item.att_sku,
                  }))}
                  value={sku || null}
                  onChange={this.onSkuSelectSingle.bind(this)}
                />
                <div style={styles.switch}>
                  <Switch
                    disabled={loading}
                    checked={activeListingsOnlyListing}
                    onChange={(e) => this.handleListingSwitch()}
                  />
                  <h2 style={styles.bold}>Active listings only</h2>
                </div>
              </div>
              <div>
                <Button onClick={this.exportListingStatus}>CSV export</Button>
              </div>
              {this.getListingTable()}
            </FetchView>
          </Container>
        </>
      );
    }

    return (
      <>
        <NavigationBar title="POSOverview" />
        <Container style={{ textAlign: 'center' }}>
          <Button
            onClick={this.handleViewChange}
            style={!isListingStatusView ? styles.activeBtn : styles.btn}
          >
            Standard
          </Button>
          <Button
            onClick={this.handleViewChange}
            style={isListingStatusView ? styles.activeBtn : styles.btn}
          >
            Listing Status
          </Button>
          <FetchView stores={[ItemStore]}>
            <div className="filter">
              <Select
                className={'filter-select'}
                isMulti
                placeholder={`Products`}
                isDisabled={loading}
                options={ItemStore.list.map((item) => ({
                  label: `${item.att_sku}`,
                  value: item.att_sku,
                }))}
                onChange={this.onSkuSelectMulti.bind(this)}
                value={skus.length > 0 ? skus : null}
              />
              <Select
                className={'filter-select'}
                placeholder={`Metric`}
                isDisabled={loading}
                options={metrics}
                onChange={(selected) => this.selectMetric(selected)}
                value={selectedMetric}
              />
              <div style={styles.switch}>
                <Switch
                  disabled={loading}
                  checked={activeListingsOnly}
                  onChange={(e) => this.handleSwitch()}
                />
                <h2 style={styles.bold}>Active listings only</h2>
              </div>
            </div>
            <div>
              <Button onClick={this.export}>CSV export</Button>
            </div>
            {this.getTable()}
          </FetchView>
        </Container>
      </>
    );
  }
}

const styles = {
  activeBtn: {
    backgroundColor: '#485fc7',
    color: 'white',
    margin: '5px',
  },
  btn: {
    margin: '5px',
  },
  filter: {
    marign: 'auto',
  },
  switch: {
    display: 'flex',
    alignItems: 'center',
  },
  bold: {
    fontWeight: 'bold',
  },
};

export default POSOverview;
